import { c as _c } from "react/compiler-runtime";
import { cloneElement } from 'react';
import Image from 'next/image';
import { fmtTimeFromString, monthDay } from '@/shared/dates';
import { formatLocationName } from '@/shared/text';
import LocationPin from 'assets/icons/location_pin.svg';
import alarm from 'assets/icons/alarm.svg';
import MapPin from 'assets/icons/map-pin.svg';
import BaseCard, { Meta } from '../atoms/BaseCard';
function EventCard(t0) {
  const $ = _c(39);
  let {
    e,
    eventDate,
    typeBadge,
    detailsLabel,
    onClick,
    showActionArea: t1,
    metasDirection: t2,
    isActive: t3
  } = t0;
  const showActionArea = t1 === undefined ? true : t1;
  const metasDirection = t2 === undefined ? "responsive" : t2;
  const isActive = t3 === undefined ? false : t3;
  const firstOccurrence = e.firstOccurrence || e.occurances[0];
  if ((!eventDate || !(eventDate instanceof Date)) && firstOccurrence) {
    eventDate = firstOccurrence.date;
  }
  const slug = e.slug ?? e.id;
  const href = `/event/${slug}`;
  const hasHref = typeof href === "string" && href.length > 0;
  let t4;
  if ($[0] !== eventDate) {
    t4 = eventDate && !isNaN(Date.parse(eventDate));
    $[0] = eventDate;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const hasValidDate = t4;
  let dateTime;
  let t5;
  let timeText;
  if ($[2] !== e.title || $[3] !== eventDate || $[4] !== firstOccurrence || $[5] !== hasValidDate) {
    const {
      mon,
      day,
      dateTime: t6
    } = hasValidDate ? monthDay(eventDate) : {};
    dateTime = t6;
    let t7;
    if ($[9] !== eventDate || $[10] !== firstOccurrence || $[11] !== hasValidDate) {
      t7 = hasValidDate ? fmtTimeFromString(firstOccurrence.start, eventDate) : "";
      $[9] = eventDate;
      $[10] = firstOccurrence;
      $[11] = hasValidDate;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    timeText = t7;
    t5 = hasValidDate ? <div className="flex min-h-15 relative h-full w-[98px] lg:mr-0 -ml-5 lg:ml-0 items-center justify-center rounded-2xl lg:py-4 lg:px-6 font-extrabold"><div className="text-xs capitalize tracking-wide text-center text-[#323232] leading-[1em] max-h-15">{mon?.charAt(0).toUpperCase() + mon?.slice(1).toLowerCase()}<span className="text-4xl block leading-[1em]">{day}</span></div><div aria-hidden="true" className="w-px absolute xl:right-2 lg:right-1 right-2 lg:top-4 lg:bottom-4 top-0 bottom-0 self-stretch rounded-full bg-slate-200" /></div> : <div className="lg:min-h-[104px] lg:h-full lg:w-[98px] w-[100px] h-[90px] overflow-hidden rounded-lg relative mb-auto lg:mb-0"><Image src="/images/event.jpg" alt={e.title || ""} width={98} height={104} sizes="110px" className="h-full w-full object-cover absolute inset-0" /></div>;
    $[2] = e.title;
    $[3] = eventDate;
    $[4] = firstOccurrence;
    $[5] = hasValidDate;
    $[6] = dateTime;
    $[7] = t5;
    $[8] = timeText;
  } else {
    dateTime = $[6];
    t5 = $[7];
    timeText = $[8];
  }
  const leftContent = t5;
  const communityDisplay = e.communityNames?.length > 0 ? e.communityNames[0] : null;
  let t6;
  if ($[13] !== communityDisplay) {
    t6 = communityDisplay && <Meta iconSrc={MapPin} alt="community" key="community">{communityDisplay}</Meta>;
    $[13] = communityDisplay;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== e.locationName) {
    t7 = e.locationName && <Meta iconSrc={LocationPin} alt="location pin" key="loc">{formatLocationName(e.locationName)}</Meta>;
    $[15] = e.locationName;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== dateTime || $[18] !== eventDate || $[19] !== timeText) {
    t8 = eventDate && <Meta iconSrc={alarm} width={13} height={10} alt="alarm" className="w-3.5 h-auto" key="time"><time dateTime={dateTime ?? undefined}>{timeText}</time></Meta>;
    $[17] = dateTime;
    $[18] = eventDate;
    $[19] = timeText;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== typeBadge) {
    t9 = typeBadge && cloneElement(typeBadge, {
      key: "type"
    });
    $[21] = typeBadge;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t6 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t10 = [t6, t7, t8, t9].filter(Boolean);
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  const metas = t10;
  let t11;
  if ($[28] !== detailsLabel || $[29] !== e.title || $[30] !== hasHref || $[31] !== href || $[32] !== isActive || $[33] !== leftContent || $[34] !== metas || $[35] !== metasDirection || $[36] !== onClick || $[37] !== showActionArea) {
    t11 = <BaseCard href={href} title={e.title} content={leftContent} metas={metas} featured={hasHref} detailsLabel={detailsLabel} onClick={onClick} showActionArea={showActionArea} metasDirection={metasDirection} isActive={isActive} />;
    $[28] = detailsLabel;
    $[29] = e.title;
    $[30] = hasHref;
    $[31] = href;
    $[32] = isActive;
    $[33] = leftContent;
    $[34] = metas;
    $[35] = metasDirection;
    $[36] = onClick;
    $[37] = showActionArea;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  return t11;
}
export default EventCard;